import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const InvasiveHealthRow = ({ image, imagealt, title, text, border }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className={`ihealth-row ${border && 'border'}`}>
        <div className="ihealth-logo">
          <img alt={imagealt || ''} src={image || ''} />
        </div>
        <div className="ihealth-text">
          <div className="title">{title}</div>
          <div className="text">{text}</div>
        </div>
      </div>

      <style jsx>{`
        .ihealth-row {
          display: flex;
          margin: 10px;
          padding-top: 20px;
          padding-bottom: 20px;
        }
        .ihealth-row.border {
          border-bottom: 1px solid ${theme.colors.primary};
        }
        .ihealth-logo img {
          max-width: 76px;
          width: auto;
        }
        .ihealth-text {
          padding-left: 10px;
        }
        .ihealth-text .title {
          font-size: 14px;
          font-weight: bold;
          color: ${theme.colors.ihealthtext};
        }
        .ihealth-text .text {
          font-size: 14px;
          color: ${theme.colors.ihealthtext};
        }
      `}</style>
    </>
  );
};

InvasiveHealthRow.propTypes = {
  border: PropTypes.bool,
  image: PropTypes.string,
  imagealt: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
};

InvasiveHealthRow.defaultProps = {
  border: false,
  deal: null,
  image: '',
  imagealt: '',
  text: '',
  title: '',
};

export default InvasiveHealthRow;
